import { render, staticRenderFns } from "./ExpandMore.vue?vue&type=template&id=ba611e74&scoped=true"
import script from "./ExpandMore.vue?vue&type=script&lang=js"
export * from "./ExpandMore.vue?vue&type=script&lang=js"
import style0 from "./ExpandMore.vue?vue&type=style&index=0&id=ba611e74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba611e74",
  null
  
)

export default component.exports